/* eslint no-param-reassign: "off" */
import { defineStore } from 'pinia';

function getDefaultState() {
  return {
    userId: undefined,
    userPermissions: [],
  };
}

const useGlobalStore = defineStore('global', {
  state: () => ({
    ...getDefaultState(),
    isLoggingOut: false,
  }),
  getters: {
    isLoggedIn(state) {
      return Boolean(state.userId);
    },
  },
  actions: {
    logIn(payload) {
      this.userId = payload.id;
      this.userPermissions = payload.user_permissions ?? [];
    },
    logOut() {
      Object.assign(this, getDefaultState());
    },
  },
});

export default useGlobalStore;
